import { Table } from 'antd';
import type { TableProps, TablePaginationConfig } from 'antd';
import styled from 'styled-components';

// Styled container for the table with glassmorphism effect
const GlassTableContainer = styled.div`
  position: relative;
  z-index: 1;

  .ant-pagination {
    display: flex;
    justify-content: center;
    margin: 16px 0;
  }
`;

// Add effect divs for the glassmorphism aesthetic
const GlassMorphismEffect = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(172, 73, 73, 0.2) 0%, rgba(172, 73, 73, 0) 70%);
  border-radius: 50%;
  opacity: 0.6;
  z-index: -1;
  pointer-events: none;
`;

export type GlassTableProps<RecordType> = TableProps<RecordType> & {
  // No additional props needed at this point, but we can add them later if needed
};

// Generic table component with glassmorphism styling
export function GlassTable<RecordType extends object = any>(
  props: GlassTableProps<RecordType>
) {
  // Standardize pagination props to ensure centered pagination across all tables
  const standardPaginationProps: TablePaginationConfig = {
    position: ["bottomCenter"],
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total: number) => `Total ${total} items`,
    size: "default",
    defaultPageSize: 10,
    pageSizeOptions: ["10", "20", "50", "100"],
    ...(props.pagination && typeof props.pagination !== 'boolean' ? props.pagination : {})
  };

  return (
    <GlassTableContainer className="glassmorphism-card">
      <GlassMorphismEffect style={{ top: '-100px', right: '50px' }} />
      <GlassMorphismEffect style={{ bottom: '-100px', left: '50px' }} />
      
      <Table
        {...props}
        className="glass-table"
        pagination={props.pagination === false ? false : standardPaginationProps}
      />
    </GlassTableContainer>
  );
}

export default GlassTable; 